<template>
  <div>

    <!-- page load para incluir onde precisar -->
    <v-overlay :value="pageLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- alerta informativo de sucesso em baixo da tela -->
    <v-snackbar
      v-model="snackbarSuccess"
      :timeout="timeout"
      color="success"
      shaped
    >
      {{ confirmationMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          v-bind="attrs"
          @click="snackbarSuccess = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

<!-- alerta informativo de erro em baixo da tela -->
    <v-snackbar
      v-model="snackbarError"
      :timeout="timeout"
      color="error"
      shaped
    >
      {{ errorMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          v-bind="attrs"
          @click="snackbarError = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>

export default {
  data() {
    return {
      snackbarSuccess: false,
      snackbarError: false,
      confirmationMessage: "",
      errorMessage: "",
      timeout: 10000,
    };
  },
  components: {
  },
  watch: {
  },
  props: {
    pageLoading: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    showConfirmationMessage: function(message) {
      this.snackbarSuccess = true;
      this.confirmationMessage = message;
    },
    showErrorMessage: function(message) {
      this.snackbarError = true;
      this.errorMessage = message;
    },
  },
  created() {
  }
};
</script>

<style scoped></style>
